import _ = require('underscore');

import { Messages } from '../../../../codegen/Localize';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { deleteSubscriptions } from '../../../actions/spaces/SubscriptionsActions';
import { IEntityAction } from './IEntityAction';

export const UnsubsribeFromSubscriptionsEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: 'unsubscribe-subscriptions',
  translateName: Messages.unsubscribe_action,
  isVisible: () => true,
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => deleteSubscriptions(subscriptions)
};
